module.exports = __webpack_public_path__ + "img/Ressouces_Mouseover.9c8350fa.png";